<nz-modal
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzContent]="nzModalContent"
  [nzClassName]="'modal-m-t-30 modal-add-group'"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onEmitCloseModal(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation] *ngIf="userType === 'expert'">
      <h2 class="text-title-md-bold">¿Estás seguro de cancelar la cita?</h2>
    </div>
    <div class="container-steps-modal" [@fadeInAnimation] *ngIf="userType === 'patient'">
      <h2 class="text-title-md-bold title-modal">Cancelar cita</h2>
      <p class="text-info mt-xxs">Por favor contacta a la sucursal para realizar cambios en tu cita</p>
    </div>
  </ng-template>

  <ng-template #nzModalContent>
    <p class="text-info text-start" *ngIf="userType === 'expert'">Se notificará al paciente de la cancelación</p>
    <div class="container-footer-modal" *ngIf="userType === 'patient' && branchEmail">
      <div nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzXs]="'24'">
          <p class="text-title mb-xs">Correo electrónico de la sucursal</p>
          <p *ngIf="branchEmail" nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchEmail" class="d-flex text-info mb-xs">{{ branchEmail }}</p>
        </div>
        <div nz-col [nzXs]="'24'">
          <div nz-row [nzGutter]="[16, 16]">
            <div nz-col [nzXs]="'24'" [nzMd]="'12'">
              <p class="text-title  mb-xs">Teléfono(s) de la sucursal</p>
              <ng-container *ngFor="let branchPhone of branchPhones">
                <div class="d-flex align-items-center">
                  <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchPhone.areaCode + branchPhone.phoneNumber"
                     class=" d-flex text-info mb-xxs">
                    {{ '(' + branchPhone.areaCode + ') ' + branchPhone.phoneNumber }}
                  </p>
                  <span class="text-info-sm ml-xxs" *ngIf="branchPhone.ext">extensión: {{ branchPhone.ext }}</span>
                </div>
              </ng-container>
            </div>
            <div nz-col [nzXs]="'24'" [nzMd]="'12'">
              <p class="text-title  mb-xs">Teléfono(s) de la clínica</p>
              <ng-container *ngFor="let clinicPhone of clinicPhones">
                <div class="d-flex align-items-center">
                  <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                     class="d-flex text-info mb-xxs">
                    {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
                  </p>
                  <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
 <!--     <p class="text-title mb-xs">Correo electrónico de la sucursal</p>
      <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchEmail" class="text-info">{{ branchEmail }}</p>
      <div nz-row [nzGutter]="[30, 30]" class="mt-xs">
        <div nz-col nzXs="24" nzMd="12" nzLg="12">
          <p class="text-title mt-md mb-xs">Teléfono(s) de la sucursal</p>
          <ng-container *ngFor="let branchPhone of branchPhones">
            <div class="d-flex align-items-center">
              <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchPhone.areaCode + branchPhone.phoneNumber"
                class="text-info mb-xxs">
                {{ '(' + branchPhone.areaCode + ') ' + branchPhone.phoneNumber }}
              </p>
              <span class="text-info-sm ml-xxs" *ngIf="branchPhone.ext">extensión: {{ branchPhone.ext }}</span>
            </div>
          </ng-container>
        </div>
        <div nz-col nzXs="24" nzMd="12" nzLg="12">
          <p class="text-title mt-md mb-xs">Teléfono(s) de la clínica</p>
          <ng-container *ngFor="let clinicPhone of clinicPhones">
            <div class="d-flex align-items-center">
              <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                class="text-info mb-xxs">
                {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
              </p>
              <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
            </div>
          </ng-container>
        </div>
      </div>-->
    </div>

    <!--Cuando es una cita virtual, no se traen datos de la cliinica-->
    <div class="container-footer-modal" *ngIf="userType === 'patient' && !branchEmail && clinicPhones.length > 0">
      <div class="tw-w-full" nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzXs]="'24'" >
          <p class="text-title  mb-xs">Teléfono(s) de la clínica</p>
          <ng-container *ngFor="let clinicPhone of clinicPhones">
            <div class="d-flex align-items-center">
              <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                 class="d-flex text-info mb-xxs">
                {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
              </p>
              <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" [@fadeInAnimation] *ngIf="userType === 'expert'">
      <button
        (click)="onEmitCloseModal(false)"
        nz-button nzType="primary" nzGhost>
        NO QUIERO</button>
      <button
        (click)="onEmitCloseModal(true)"
        nz-button nzType="primary" nzDanger>
        SÍ QUIERO CANCELARLA
      </button>
    </div>
    <div class="container-footer-modal" [@fadeInAnimation] *ngIf="userType === 'patient'">
      <button
        (click)="onEmitCloseModal(true)"
        nz-button nzType="primary">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        CERRAR
      </button>
    </div>
  </ng-template>
</nz-modal>
